exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-wrapper .form-group[data-v-142e8904]:last-of-type {\n  margin-bottom: 0 !important;\n}\n.focused-input-image object[data-v-142e8904] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%);\n}\n@media (max-width: 767px) {\n.focused-input-image[data-v-142e8904] {\n    margin-top: 15px;\n}\n.focused-input-image object[data-v-142e8904] {\n    position: relative;\n    top: 0;\n    left: 0;\n    transform: none;\n}\n}\n", ""]);

// exports
